@charset "UTF-8";

/* src/app/forms/formview/form-field-properties/form-field-properties-detail-actions-params/form-field-properties-detail-actions-params.component.scss */
.grid-view {
  position: relative;
  height: 100%;
  min-height: 200px;
  min-height: 200px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.info-title {
  font-size: 80%;
  font-weight: 500;
  color: var(--tem-ink);
}
.info-desc {
  font-size: 80%;
  color: var(--tem-muted);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  text-align: center;
}
.props-grid-params {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 2fr 2fr 1fr;
  align-items: center;
  gap: 4px;
  border-bottom: 1px solid var(--tem-border);
  padding: 4px;
}
.props-grid-header {
  background: var(--tem-surface-2);
  border-radius: var(--tem-radius) var(--tem-radius) 0 0;
}
.actions-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.left-edit {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 30%;
  padding-left: 4px;
  padding-right: 4px;
}
.container-data {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-right: 4px;
  min-height: 200px;
  position: relative;
}
.container-formula-tester {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 4px;
  padding-top: 4px;
  overflow: auto;
  min-height: 150px;
  height: 150px;
}
.right-edit {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 70%;
  padding-left: 4px;
  padding-right: 4px;
}
app-formula-tester {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.fields {
  width: 100%;
  display: flex;
  flex-direction: row;
  font-size: 10px;
  padding-left: 10px;
  height: 100%;
  justify-content: space-between;
  align-items: center;
}
search-input {
  height: 40px !important;
  width: 100%;
}
.edit-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.form-edit-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 6px;
}
.detail-item {
  font-size: 80%;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 10px;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  overflow: auto;
  height: 100%;
}
.detail-item-tipo {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
}
.span1 {
  margin-left: 10px;
}
.float-add-button {
  position: absolute;
  right: 15px;
  bottom: 0;
  top: 60px;
  z-index: 10;
}
textarea {
  height: 100%;
  resize: none;
}
.action-button {
  display: flex;
  width: 100%;
  flex-direction: row;
  border-top: 1px solid var(--tem-border);
  justify-content: flex-end;
  z-index: 10;
  padding-top: 6px;
}
.grid-lines {
  cursor: pointer;
}
.grid-main-lines {
  display: grid;
  overflow: auto;
  padding-right: 10px;
}
.grid-main-header {
  display: grid;
  overflow: hidden;
  padding-right: 14px;
}
.detail-item-tipo-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.detail-item-tipo-box-main {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}
.detail-item-tipo-box-listoption {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 4px;
}
.list-option-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 4px;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.textarea {
  height: 100%;
}
.full {
  height: 100%;
}
/*# sourceMappingURL=form-field-properties-detail-actions-params.component.css.map */
